import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { FaLightbulb } from 'react-icons/fa';
import styled from 'styled-components';
import { CheckboxProps } from 'semantic-ui-react';

import { useAppSelector } from '@/store';
import { organizationAffiliationStore } from '@/store/organization/affiliation';
import { Label } from '@/components/shared/Label';
import { AdminCards } from './AdminCards';

export type Props = {
  value: number[];
  error: string | (string | undefined)[];
  onChange: (data: CheckboxProps, adminId: number) => void;
};

export const Admins: React.FC<Props> = ({ value, error, onChange }) => {
  const admins = useAppSelector(
    organizationAffiliationStore.selectors.activeAdmins,
  );
  const { t } = useTranslation();

  return (
    <Styled>
      <div id="adminIds" className={classnames('field', { error })}>
        <label>{t('models.subscription.admins')}</label>
        <div className="admins">
          <AdminCards
            admins={admins}
            value={value}
            onChange={onChange}
            error={!!error}
          />
          <div className="hint with-icon">
            <FaLightbulb className="icon" />
            <span>
              {t('ui.expression.adminInvitationRequiredBeforeApplication')}
            </span>
          </div>
          {error && <Label>{error}</Label>}
        </div>
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  .hint.admin-reset {
    width: 100%;
  }

  .with-icon {
    position: relative;
    padding-left: 18px;

    .icon {
      position: absolute;
      top: 3px;
      left: 1px;
    }
  }
`;
